import { Icon3d3d, Icon3dAlert, Icon3dCycle, Icon3dDetect, Icon3dMap2, Icon3dMeter, Icon3dSchedule } from '@assets/images/icon';
import { cameraBannerBg, cameraBannerProduct } from '@assets/images/main/camera';
import { BannerOutdoorDesktop } from '@assets/images/main/home';
import { IconGpsDeviceOff, IconGpsDeviceOn, IconGpsInv, IconGpsTagOff, IconGpsTagOn, IconLoraInv, IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { IconBlueScan, IconBlueShield } from '@assets/images/main/icon/blue';
import { loraGatewayOn, loraGatewayOff, loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm } from '@assets/images/main/index';
import { outdoorBannerBG, outdoorBannerImg } from '@assets/images/main/outdoor';
import { screenViewOutdoor1, screenViewOutdoor2, screenViewOutdoor3 } from '@assets/images/main/screenView';

import { ReactComponent as SvgBinocularsLine } from '@assets/images/icon/svg/binoculars-line.svg';
import { ReactComponent as SvgGlobal } from '@assets/images/icon/svg/global.svg';
import { ReactComponent as SvgPhoneLine } from '@assets/images/icon/svg/phone-line.svg';

export default {
  banner: {
    title: '광활한 공간도, 움직이는 자산도,<br/>오브로 화면에서 단순하게.',
    desc: '차량, 자산, 장비의 움직임을 GPS로 추적하고<br/>LTE와 LoRA 수신기를 통해 실시간 위치 정보가 ORBRO OS에 연동됩니다.',

    schemeTitle: '당신에게 맞는 야외 위치추적 방법을 알아보세요',
    bgImg: outdoorBannerBG,
    productImg: outdoorBannerImg,
  },

  bannerData: [
    {
      icon: IconGpsDeviceOn,
      iconInv: IconGpsInv,
      iconOff: IconGpsDeviceOff,
      image: '',
      iconText: 'GPS Device',
      sub: 'New',
      link: '/outdoor/gps',
    },
    {
      icon: IconGpsTagOn,
      iconInv: IconLoraInv,
      iconOff: IconGpsTagOff,
      image: '',
      iconText: 'GPS Tag(LoRA)',
      sub: 'New',
      link: '/outdoor/lora',
    },
  ],

  screenView: {
    title: '모바일의 모든 움직임을, 하나의 지도에서',
    data: [
      {
        icon: SvgBinocularsLine,
        text: '관제 센터 모니터링',
        img: screenViewOutdoor1,
      },
      {
        icon: SvgGlobal,
        text: '전세계 고해상도 지도 제공',
        img: screenViewOutdoor2,
      },
      {
        icon: SvgPhoneLine,
        text: '모바일 기종과 사용자 정보 표시',
        img: screenViewOutdoor3,
      },
    ],
  },

  func: {
    title: '기능 더 알아보기',
    desc: '카메라의 다양한 기능을 확인해 보세요.',

    data: [
      {
        img: Icon3dMap2,
        title: '이동 경로 실시간 추적',
        desc: '차량, 장비, 컨테이너 등 실외 자산의 이동 경로를 실시간으로 지도에 시각화하여 현재 위치와 과거 이동 이력을 한눈에 파악할 수 있습니다.',
      },
      {
        img: IconBlueScan,
        title: '구역 지정 및 이탈 감지',
        desc: '항만, 야드, 도로 작업 구역 등 특정 지역을 지정해두고, 자산이 해당 구역을 벗어나거나 진입 시 자동 알림을 생성합니다.',
      },
      {
        img: Icon3dMeter,
        title: '장비 운행 시간 분석',
        desc: 'GPS 데이터를 기반으로 차량이나 중장비의 운행/대기/정지 시간을 자동으로 분류해 장비 가동률과 활용도를 분석할 수 있습니다.',
      },
      {
        img: Icon3dAlert,
        title: '속도 이상 감지 및 알림',
        desc: '설정된 속도 기준을 초과하거나 예상 이동 패턴과 다른 급격한 움직임이 발생하면 자동으로 관리자에게 알림을 전송합니다.',
      },
      {
        img: Icon3dDetect,
        title: 'GPS 단말 상태 원격 모니터링',
        desc: '각 단말기의 배터리 잔량, 마지막 통신 시점, 위치 갱신 빈도 등을 서버에서 원격으로 확인하고 상태 이상 시 경고를 제공합니다.',
      },
      {
        img: Icon3dSchedule,
        title: '자산 중심 리포트 자동 생성',
        desc: '자산별 위치 이력, 체류 구간, 운행 거리, 구역 진입·이탈 로그 등을 기반으로 일/주/월 단위의 운영 리포트를 자동 생성할 수 있습니다.',
      },
    ],
  },

  FAQ: [
    {
      title: 'ORBRO의 GPS 위치추적 시스템은 어떤 방식으로 작동하나요?',
      description:
        'GNSS(GPS) 신호를 수신하는 단말기가 실외 자산의 위치를 실시간으로 계산하고, LoRA 또는 LTE-M 통신을 통해 ORBRO Server로 전송합니다. 해당 위치는 ORBRO OS에서 지도 기반으로 시각화됩니다.',
    },
    {
      title: 'LoRA 수신 키트는 어떤 역할을 하나요?',
      description:
        'LoRA 수신 키트는 GPS 단말기에서 송신하는 신호를 수신하고, 유선(PoE) 통신으로 ORBRO Server에 데이터를 전달하는 역할을 합니다. 넓은 공간에 설치된 수신기로 실시간 위치 데이터가 연동됩니다.',
    },
    {
      title: '전원이 없는 야외 공간에서도 사용할 수 있나요?',
      description:
        'GPS 단말기는 자체 배터리로 최대 150일 사용이 가능하므로 전원 인프라가 없는 환경에서도 운용 가능합니다. 수신기는 PoE를 사용하므로 전원이 필요한 고정형 장비입니다.',
    },
    {
      title: '실시간으로 추적이 가능한가요?',
      description:
        '네. GPS 단말은 주기적으로 위치를 송신하며, 수신된 데이터는 거의 실시간으로 서버에 반영됩니다. 전송 주기는 설정에 따라 조정 가능하며, 보통 10초~1분 간격으로 설정됩니다.',
    },
    {
      title: 'GPS 기반 위치추적이 실내 RTLS보다 좋은가요?',
      description:
        '상황에 따라 다릅니다. GPS는 실외 환경에 최적화되어 있으며, 넓은 공간과 자율 이동 자산에 적합합니다. 반면 RTLS는 실내 고정밀 추적에 강점이 있습니다. ORBRO는 실내외 통합 운영이 가능합니다.',
    },
    {
      title: '위치 데이터는 저장되나요?',
      description:
        '네. 수집된 위치 데이터는 ORBRO Server에 저장되며, 자산별 이동 이력, 출입 기록, 체류 시간 분석 등에 활용됩니다. 모든 데이터는 접근 권한과 암호화 정책에 따라 안전하게 관리됩니다.',
    },
    {
      title: '단말기 상태도 확인할 수 있나요?',
      description:
        '가능합니다. 각 단말기의 배터리 잔량, 마지막 통신 시점, 신호 품질 등을 ORBRO OS에서 원격으로 확인할 수 있으며, 이상 발생 시 자동 알림이 전송됩니다.',
    },
    {
      title: '실시간 알림도 설정할 수 있나요?',
      description:
        '네. 지정 구역을 벗어나거나, 예상 동선과 다른 움직임, 비정상 속도 등이 감지되면 관리자에게 실시간으로 알림(Push, Email, Webhook 등)이 전송됩니다.',
    },
  ],
};
